require 'angular'
moment = require 'moment'
_ = require('lodash')

{ partitionAndSort, get_from_list } = require '../../utils'

module.exports = (
  $analytics,
  $http,
  $uibModal,
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  adverseTermsLists,
  Api,
  countries,
  countryAliases,
  languages,
  managedUsers,
  processes,
  states,
  workflowTemplates,
  User
) ->

  # New objects to be created by this page
  $scope.setProject = (project) ->
    $scope.project = project or new Api.Project owner: User.id, heimdall_alert: $state.params.heimdall_alert
    if $scope.processes.length > 0 and not $scope.project.process
      $scope.project.process = $scope.processes[0].id
    if $scope.project.name
      $scope.stopSettingProjectName()

  $scope.setWorkflows = (workflows) ->

    for workflow in workflows or []
      # in order to simplified model binding
      workflow.date_of_birth = workflow.date_of_birth?.from_date

      # TODO: Backwards compatibility. Can remove if we're sure we don't have any workflows without entities
      if workflow.query and (workflow.simple_names or []).length is 0
        workflow.simple_names = [{'name': workflow.translated_query or workflow.query}]

    $scope.workflows = workflows or [
      new Api.Workflow
        query: $state.params.entity,
        simple_names: [{'name': $state.params.entity}],
        entity_type: null,
        countries: []
    ]

  $scope.addWorkflow = () ->
    $scope.workflows.push new Api.Workflow simple_names: [{'name': ''}], entity_type: null, countries: []

  $scope.removeWorkflow = (idx) ->
    $scope.workflows.splice(idx, 1)

  $scope.duplicate = (idx) ->
    newWorkflow = new Api.Workflow angular.copy($scope.workflows[idx])
    newWorkflow.disabled = false
    $scope.workflows.splice(idx + 1, 0, newWorkflow)

  $scope.setAssignedTo = (userId) ->
    $scope.assigned_to = userId

  $scope.newWorkflows = (workflows) ->
    (w for w in workflows when w.disabled isnt true).length

  $scope.newNameVariations = (workflows) ->
    return _.flatten(
      (variation for variation in workflow.simple_names when variation.new) for workflow in workflows).length

  $scope.startSearches = () ->
    $state.go('project', {projectId: $scope.project.id})

  $scope.assignProject = (cb) ->
    assign = new Api.AssignProject project: $scope.project.id, owner: $scope.assigned_to
    assign.$save().then cb

  $scope.saveProjectComplete = (response) ->
    $analytics.eventTrack "Saved project (entites)",
      category: "Success"

    $state.go('start')
    $rootScope.message =
    "Report <strong>#{$scope.project.name}</strong> has been added."

  @formatDatePickerValue = (val) ->
    return moment(val).format("YYYY-MM-DD")

  @hasWebsiteAddress = (workflow) ->
    return workflow.site?.site?.length > 0

  $scope._workflowToSave = (project) =>
    workflows = []
    $scope.project.id = project.id

    for w, idx in $scope.workflows when w.disabled isnt true
      # Do not set `site` in the payload if it is not fully defined / non-empty
      # as we the site serializer does not allow null for the `site` field
      shallowClone = _.pick w, (value, key) =>
        key != 'site' or @hasWebsiteAddress(w)

      workflow_copy = new Api.Workflow(shallowClone)

      workflow_copy.id = undefined
      # Find the right name for this id
      workflow_copy.name = (i.name for i in $scope.workflowTemplates when i.id is workflow_copy.template)[0]
      workflow_copy.order = idx
      workflow_copy.project = project.id

      # Make sure we don't submit empty names
      workflow_copy.simple_names = (
        {
          'name': name.name,
          'country': name.country if name.country?
          'adverse_terms_id': name.adverse_terms_id if name.adverse_terms_id?
          'is_translated': name.is_translated if name.is_translated?
        } for name in workflow_copy.simple_names when name.name isnt '')

      # Format date of birth values for API
      # date_of_birth is copied to date_of_birth.from_date and date_of_birth.to_date
      # in order to keep backend unchanged.
      if workflow_copy.date_of_birth?
        date_of_birth = @formatDatePickerValue(workflow_copy.date_of_birth)
        workflow_copy.date_of_birth =
          from_date: date_of_birth
          to_date: date_of_birth

      workflows.push(workflow_copy)

    return workflows

  $scope.saveProject = (projectForm) ->
    projectForm.$submitted = true

    if !projectForm.$valid or $scope.workflows.length == 0
      return

    $scope.searching = true # disable the button
    $scope.project.workflows = $scope._workflowToSave($scope.project)
    $scope.project.$save()
      .then (
        (project) ->
          if $scope.assigned_to != User.id
            $scope.assignProject ->
          $scope.searching = false
          $scope.saveProjectComplete()
      ),
      (error) ->
        $scope.error_message = "There was a problem saving your project: #{error.statusText}"
        $scope.searching = false # enable the button
        $analytics.eventTrack "Error saving project",
          category: "Error"
          label: error.statusText

        console.error error

  # =========================
  # -------- Display --------
  # =========================

  $scope.getWorkflowStepsTooltip = ( workflow ) ->
    workflowStepNames = ( step.name for step in workflow.steps )
    workflowStepNames.join( '<br/>')

  $scope.stateNamesByProcess = ( process, states ) ->
    (state.name for state in states when state.process is process.id)

  $scope.getStatesTooltip = ( process, states ) ->
    stateNames = $scope.stateNamesByProcess( process, states )
    'States:<br/>' + stateNames.join('<br/>')

  $scope.getSubjectName = ( workflow ) ->
    if workflow.simple_names?[0]?
      return workflow.simple_names[0].name
    else if workflow.query?
      return workflow.query
    else
      return undefined

  $scope.getFirstSubjectName = () ->
    if $scope.workflows[0]?
      $scope.getSubjectName($scope.workflows[0])

  # =========================
  # --------- Scope ---------
  # =========================

  $scope.user = User
  $scope.processes = processes
  $scope.states = states

  $scope.setProject()
  $scope.setWorkflows()
  $scope.adverseTermsLists = adverseTermsLists
  $scope.assignedToSelect = User.id
  $scope.setAssignedTo User.id
  $scope.managedUsers = managedUsers
  $scope.adverseTermsLists.unshift(name: "Select adverse terms")
  $scope.languagesPartitioned = partitionAndSort(languages, 'id', 'name')
  $scope.workflowTemplates = workflowTemplates
  # cherry pick to improve performance of ui-select
  $scope.countries = ({ id: c.id, name: c.name , iso_code: c.iso_code, aliases: countryAliases[c.name], subdivisions: c.subdivisions } \
    for c in countries)

  for c in $scope.countries
    if c.iso_code == "glo"
      c.name = $scope.user.unknown_country_name

  $scope.stopSettingProjectName = $scope.$watch 'getFirstSubjectName()', (subjectName) ->
    $scope.project.name = subjectName
